import React from 'react';

const SessionTimeoutModal = ({ show, onContinue, onLogout }) => {
  if (!show) return null;
  return (
    <div className="modal d-block">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Session Timeout</h5>
          </div>
          <div className="modal-body">
            <p>You have been inactive for a while. Do you want to continue your session?</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" onClick={onLogout}>Logout</button>
            <button className="btn btn-primary" onClick={onContinue}>Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
